import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursorList: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCursorList"><Path d="M11.9375 16.4375L15.9554 12.4196L3.5 8L7.91964 20.4554L11.9375 16.4375ZM11.9375 16.4375L17 21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 3.5H10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 7.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCursorList;
